module.exports = __webpack_public_path__ + "static/media/comment.cb653bd9.svg";